import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert, Grid, Label } from "~/components-shared";
import { TopicActionEnum } from "~/store/topics/types";
import { object, string } from "yup";
import InputDateControl from "~/components/InputDateControl";
import InputTimeControl from "~/components/InputTimeControl";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const TopicTargetUpdateCompleteModal = () => {
  const {
    t
  } = useTranslation();
  const topic = useSelector(topicSelectors.getSelected);
  const target = useSelector(topicSelectors.getSelectedData);
  const action = useSelector(topicSelectors.getAction);
  const status = useSelector(topicSelectors.getTargetStatus);
  const error = useSelector(topicSelectors.getTargetError);
  const dispatch = useDispatch();
  const defaultValues = {
    checkedAt: target?.checkedAt || ""
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(object().shape({
      checkedAt: string()
    })),
    defaultValues
  });
  useEffect(() => {
    if (action === TopicActionEnum.UPDATE_TARGET_COMPLETE) {
      reset(defaultValues);
    }
  }, [action]);
  const handleClose = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
  };
  const onSubmit = handleSubmit(data => {
    if (topic?.id && target?.id) {
      dispatch(topicActionCreators.updateTargetCompleteStarted(topic.id, target.id, data.checkedAt, _ref => {
        let {
          data: newTarget
        } = _ref;
        if (newTarget) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("TopicTargetUpdateCompleteModal.updated", {
              name: target.name
            }),
            timeout: 10000
          }));
        }
      }));
    }
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicTargetUpdateCompleteModal.updateComplete"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "500px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true,
    isSticky: true
  }, error), /*#__PURE__*/React.createElement(Label, {
    s: {
      mb: 2
    }
  }, t("TopicTargetUpdateCompleteModal.completionDate")), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "64% 32%",
    gap: 5
  }, /*#__PURE__*/React.createElement(InputDateControl, {
    name: "checkedAt",
    control: control
  }), /*#__PURE__*/React.createElement(InputTimeControl, {
    name: "checkedAt",
    control: control
  }))), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicTargetUpdateCompleteModal.saveDate")))));
};
export default TopicTargetUpdateCompleteModal;